import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { AuthService } from '../../../core/services/auth.service';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../core/services/apiHelper';
import { environment } from '../../../environments/environment';
import { CharterDAO } from '../../../core/services/dao/charterDAO';
import { VesselDAO } from '../../../core/services/dao/vesselDAO';

@Injectable()
export class BookingsManagerResolve implements Resolve<any> {
  constructor(
    private authService: AuthService,
    private vesselDAO: VesselDAO,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    const sessionResolve = this.authService.checkSession();
    const vesselResolve = this.vesselDAO.loadByOwnerId();

    return combineLatest([sessionResolve, vesselResolve]).pipe(
      map(([sessionResolve, vesselResolve]) => ({
        sessionResolve,
        vesselResolve,
      })),
      take(1),
    );
  }
}
